import { handleActions } from 'redux-actions'
import { List, Map } from 'immutable'
import moment from 'moment'
import { formatMessage } from 'lib/intl'
import { createTableObj } from 'helpers/common'
import {
  LOAD_FILTERS,
  SET_FILTERS,
  CLEAR_FILTERS,
  LOAD_TABLE_DATA,
  SET_TABLE_DATA,
  CLEAR_TABLE_DATA,
  SET_ACTIVE_FILTER,
  SET_INIT_READY_STATE,
  SET_INIT_FILTERS,
  CLEAR_STORE,
} from './action'

// store
const initStore = () =>
  Map({
    isInitReady: false,
    isLoadTableData: true,
    initFilters: Map({}),
    filters: Map({
      sites: List([]),
      jobs: List([]),
      tasks: List([]),
      inputs: List([]),
      unitGroups: List([]),
      units: List([]),
      inputTypes: List([]),
      fieldList: List([
        { id: 'job', name: formatMessage('job') },
        { id: 'job_input', name: formatMessage('input') },
        { id: 'job_task', name: formatMessage('task') },
        { id: 'date', name: formatMessage('input_date') },
        { id: 'job_number', name: formatMessage('job_id') },
        { id: 'locus_group', name: formatMessage('unit_group') },
        { id: 'locus', name: formatMessage('unit') },
        { id: 'job_input_type', name: formatMessage('input_type') },
        { id: 'result', name: formatMessage('input_value') },
        { id: 'last_edited_by', name: formatMessage('last_edited_by') },
      ]),
    }),
    activeDateRange: Map({
      start: moment().subtract(7, 'days'),
      end: moment(),
    }),
    tableData: Map(createTableObj()),
  })

// handlers
const myJobsDataViewerReducer = handleActions(
  {
    [SET_INIT_READY_STATE]: (state, { payload }) =>
      state.set('isInitReady', Boolean(payload)),

    [LOAD_FILTERS]: (state, { payload }) =>
      state.set('isLoadTableData', Boolean(payload)),
    [SET_FILTERS]: (state, { payload }) => {
      const oldFilters = state.get('filters').toJS()

      for (const key in payload) {
        if (oldFilters.hasOwnProperty(key)) {
          // eslint-disable-next-line no-param-reassign
          state = state.setIn(['filters', key], List(payload[key]))
        }
      }

      return state
    },
    [CLEAR_FILTERS]: state => state.set('filters', initStore().get('filters')),

    [LOAD_TABLE_DATA]: (state, { payload }) =>
      state.set('isLoadTableData', Boolean(payload)),
    [SET_TABLE_DATA]: (state, action) =>
      state.set('tableData', Map(action.payload)),
    [CLEAR_TABLE_DATA]: state =>
      state.set('tableData', initStore().get('tableData')),

    [SET_INIT_FILTERS]: (state, { payload: initFilters }) =>
      state.set('initFilters', Map(initFilters)),

    [SET_ACTIVE_FILTER]: (state, { payload }) => {
      const filterTypes = {
        activeSite: 'map',
        activeDateRange: 'map',
      }

      // eslint-disable-next-line guard-for-in
      for (const key in payload) {
        let nextValue = payload[key]

        if (filterTypes.hasOwnProperty(key)) {
          switch (filterTypes[key]) {
            case 'map':
              nextValue = Map(nextValue)
              break
            case 'list':
              nextValue = List(nextValue)
              break
            default:
          }
          // eslint-disable-next-line no-param-reassign
          state = state.set(key, nextValue)
        }
      }

      return state
    },

    [CLEAR_STORE]: initStore,
  },
  initStore(),
)

export default myJobsDataViewerReducer
